import { render, staticRenderFns } from "./VerifyForm.vue?vue&type=template&id=baf0333c&scoped=true"
import script from "./VerifyForm.vue?vue&type=script&lang=js"
export * from "./VerifyForm.vue?vue&type=script&lang=js"
import style0 from "./VerifyForm.vue?vue&type=style&index=0&id=baf0333c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "baf0333c",
  null
  
)

export default component.exports